import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import {
    GetRoles,
    GetProjectCodes,
    InviteUser,
    GetUserDetails,
    ClearAction,
} from '../store/user-managment.actions';
import { Validators, FormBuilder, FormGroup, AbstractControl, FormArray, FormControl } from '@angular/forms';
import { take, map, takeUntil } from 'rxjs/operators';
import { MatSelectChange, MatCheckboxChange } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { EditProfile } from '../../profile/store/profile.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";

@Component({
    selector: 'app-user-invite',
    templateUrl: './user-invite.component.html',
    styleUrls: ['./user-invite.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserInviteComponent implements OnInit, OnDestroy {

    inviateForm: FormGroup;
    roles$;
    codes$;
    email;
    fullName;
    selectedRole;
    checkboxDisable = true;
    selectedProjects = [];
    categories: Array<string> = [];
    selectedCategory: string;
    userId;
    private stopper: Subject<void> = new Subject<void>();
    userRole: any;
    validationMsg = VALIDATION_MESSAGES;
    existingRoles: Array<string> = [];
    categoryWiseRoles: Array<any> = [];
    versionList:Array<any>=[];
    version:any=[];
    selectedV1VersionList:any=[];
    selectedV2VersionList:any=[];

    citiisV1CheckValue:boolean=false;
    citiisV2CheckValue:boolean=false;
    constructor(
        private store: Store<AppState>,
        private fb: FormBuilder,
        private location: Location,
        private activatedRoute: ActivatedRoute
    ) {
        this.inviateForm = this.fb.group({
            email: ['',Validators.compose([
                Validators.required,
                ValidationUtil.cannotBeBlank,
                this.emailValidator,
            ])],
            role: ['', Validators.required],
            // version: this.fb.array([], [Validators.required]),
            // category: ['', Validators.required],
        });
    }
    ngOnInit() {
        this.store.dispatch(new ClearAction());
        this.store.dispatch(new GetRoles());
        this.versionList=[{name:"CITIIS 1.0",value:"CITIIS 1.0",checked:false},{name:"CITIIS 2.0",value:"CITIIS 2.0",checked:false}];
        // this.version=['V1'];
        console.log(this.version);
        //this.store.dispatch(new GetProjectCodes());
        this.store.select(state => state.userManagment.roles).pipe(take(2)).subscribe(response => {
            if (response.status) {
                const categories = response.roles.map(role => role.category);
                this.categories = Array.from(new Set(categories));

                this.categories.map(category => {
                    let newObj = {
                        name: category,
                        roles: []
                    }
                    response.roles.map(role => {
                        if (role.category == category) {
                            newObj.roles.push(role)
                        }
                    })
                    this.categoryWiseRoles.push(newObj);
                })
                console.log("categoryWiseRoles", this.categoryWiseRoles);
            } else {
                return;
            }
        });


        this.userId = this.activatedRoute.snapshot.paramMap.get('id');
        if (this.userId) {
            this.store.dispatch(new GetUserDetails(this.userId));
            this.store.select(state => state.userManagment.userDetails)
                .pipe(takeUntil(this.stopper))
                .subscribe((userDetails: any) => {
                    console.log(userDetails);
                    this.existingRoles = userDetails.role;
                    if (userDetails.role) {
                        this.userRole = userDetails.role[0];
                    }
                    this.version=userDetails.version;
                    this.store.select(state => state.userManagment.roles).pipe(take(2)).subscribe(rolesList => {
                        const role = ((rolesList || {}).roles || []).filter((role: any) => {
                            return role.role.includes(this.userRole);
                        })[0];
                        const category = (role || {}).category;
                        this.selectedCategory = category;
                        this.inviateForm.patchValue({
                            email: userDetails.email,
                            role: userDetails.role,
                            // version: userDetails.version,
                            category: category
                        });
                        this.citiisV1CheckValue=userDetails.cities_1_flag;
                        this.citiisV2CheckValue=userDetails.cities_2_flag;
                        if(userDetails.cities_1_flag){
                            this.selectedV1VersionList.push({'checked':userDetails.cities_1_flag,'value':'CITIIS 1.0'});
                        }
                        if(userDetails.cities_2_flag){
                            this.selectedV2VersionList.push({'checked':userDetails.cities_2_flag,'value':'CITIIS 2.0'}); 
                        }

                    });
                    // this.inviateForm.patchValue()
                });
        }
        //this.codes$ = this.store.select(state => state.userManagment.projectCodes);
    }

    // onVersionChange(e, val) {
    //     const isArray: FormArray = this.inviateForm.get("version") as FormArray;
    //     console.log(isArray);
    //     console.log(e);
    //     if (e.checked) {
    //       isArray.push(new FormControl(val));
    //       if (!this.selectedVersionList.includes(val)) {
    //       this.selectedVersionList.push({'checked':e.checked,'value':val});
    //       }
    //     } else {
    //       let i: number = 0;
    //       console.log(val);
    //       isArray.controls.forEach((item: FormControl) => {
    //         console.log(item);
    //         console.log(item.value);
    //         if (item.value == val) {
    //           isArray.removeAt(i);
    //           return;
    //         }
    //         i++;
    //       });
    //      this.selectedVersionList.forEach((item: any) => {
    //         console.log(item);
    //         console.log(item.value);
    //         console.log(val);
    //         if (item.value == val) {
    //             // this.selectedVersionList.removeAt(i);
    //             console.log(item.value)
    //             this.selectedVersionList=this.selectedVersionList.filter(obj => obj.value !== val);

    //           return;
    //         }
    //         i++;
    //       });
    //     }
    //     this.version=isArray.value;
    //     console.log(isArray);
    //     let c= this.selectedVersionList;
    //     console.log(c);
    //     console.log(this.selectedVersionList);
    //     console.log(this.version);
    //   }
    onV1VersionChange(e, val){
        if (e.checked) {
          if (!this.selectedV1VersionList.includes(val)) {
          this.selectedV1VersionList.push({'checked':e.checked,'value':val});
          this.inviteBtnClick=false;

          }
          this.citiisV1CheckValue=true;
        } else {
          let i: number = 0;
          console.log(val);
         this.selectedV1VersionList.forEach((item: any) => {
            console.log(item);
            console.log(item.value);
            console.log(val);
            if (item.value == val) {
                // this.selectedVersionList.removeAt(i);
                console.log(item.value)
                this.selectedV1VersionList=this.selectedV1VersionList.filter(obj => obj.value !== val);

              return;
            }
            i++;
          });
          this.citiisV1CheckValue=false;
          if(this.selectedV2VersionList.length === 0){
            this.inviteBtnClick=true;
          }
          else{
            this.inviteBtnClick=false;
          }
        }
        console.log(this.selectedV1VersionList);
        console.log(this.citiisV1CheckValue);
    }
    onV2VersionChange(e, val){
        if (e.checked) {
          if (!this.selectedV2VersionList.includes(val)) {
          this.selectedV2VersionList.push({'checked':e.checked,'value':val});
          this.inviteBtnClick=false;

          }
          this.citiisV2CheckValue=true;
        } else {
          let i: number = 0;
          console.log(val);
         this.selectedV2VersionList.forEach((item: any) => {
            console.log(item);
            console.log(item.value);
            console.log(val);
            if (item.value == val) {
                // this.selectedVersionList.removeAt(i);
                console.log(item.value)
                this.selectedV2VersionList=this.selectedV2VersionList.filter(obj => obj.value !== val);

              return;
            }
            i++;
          });
          this.citiisV2CheckValue=false;
          if(this.selectedV1VersionList.length === 0){
            this.inviteBtnClick=true;
          }
          else{
            this.inviteBtnClick=false;
          }
        }
        console.log(this.selectedV2VersionList);
        console.log(this.citiisV2CheckValue);
    }

    onRoleSelectionChange(event: MatSelectChange) {
        this.roles$.pipe(take(1)).subscribe(roles => {
            roles.map(role => {
                this.selectedRole = event.value;
                if (role.role.includes(event.value)) {
                    this.checkboxDisable = role.scope.includes('global');
                }
            });
        });
    }

    onProjectSelectionChange(event: MatCheckboxChange, project) {
        if (event.checked) {
            this.selectedProjects.push(project);
        } else {
            this.selectedProjects = this.selectedProjects.filter(prj => prj.id !== project.id);
        }
    }
    inviteBtnClick:boolean=false;
    sendInvite() {
        console.log(this.selectedV1VersionList,this.selectedV2VersionList);
        
        if(this.selectedV1VersionList.length===0 && this.selectedV2VersionList.length===0){
        this.inviteBtnClick=true;
    }
        if (!this.inviateForm.valid) {
            this.inviateForm.get('role').markAsDirty();
            this.inviateForm.get('email').markAsDirty();
            this.inviateForm.get('role').markAsTouched();
            this.inviateForm.get('email').markAsTouched();
            return;
        }
        if(this.inviteBtnClick!==true){
        const inputData = this.inviateForm.value;
        console.log(inputData);
        const selectedPrjs = this.selectedProjects.map(prj => prj._id) || [];
        if (this.userId) {
            let rolesArr = this.existingRoles.concat(inputData.role);
            let filteredRolesArr = rolesArr.filter((item, index) => {
                return rolesArr.indexOf(item) === index;
            })
            // let editVersionData=inputData.version;
            let editV1VersionData=this.citiisV1CheckValue;
            let editV2VersionData=this.citiisV2CheckValue;
            // let v1Value:boolean=false;
            // let v2Value:boolean=false;
            // this.selectedVersionList.forEach((item)=>{
            //     console.log(item);
            //     if(item.value=="CITIIS 1.0"){
            //         v1Value=true;
            //     }
            //     else if(item.value=="CITIIS 2.0"){
            //         v2Value=true;
            //     }
            // })
            const payload = {
                email: inputData.email.trim(),
                role: inputData.role,
                // version: editVersionData
                cities_1_flag: editV1VersionData,
                cities_2_flag: editV2VersionData
            };
            this.store.dispatch(new EditProfile(this.userId, payload));
        } else {
            // let addVersionData=inputData.version;
            let addV1VersionData=this.citiisV1CheckValue;
            let addV2VersionData=this.citiisV2CheckValue;
            // let addv1Value:boolean=false;
            // let addv2Value:boolean=false;
            // this.selectedVersionList.forEach((item)=>{
            //     console.log(item);
            //     if(item.value=="CITIIS 1.0"){
            //         addv1Value=true;
            //     }
            //     else if(item.value=="CITIIS 2.0"){
            //         addv2Value=true;
            //     }
            // })
            const payload = {
                email: inputData.email,
                role: [...inputData.role],
                // version: addVersionData
                cities_1_flag: addV1VersionData,
                cities_2_flag: addV2VersionData
            };
            console.log(payload);
            this.store.dispatch(new InviteUser(payload));
        }
    }
    }

    emailValidator(control: AbstractControl): { [key: string]: any } | null {
        if (control.value && control.value.trim()) {
            const valid = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(control.value.trim());
            return valid
                ? null
                : { invalidEmail: { valid: false, value: control.value } };
        }
    }

    cancel() {
        this.location.back();
    }

    ngOnDestroy() {
        this.stopper.unsubscribe();
    }
}
